export default ['failure', 'balance', 'other']
